import { get } from './request'

export const getImages = (supplier: string, propertyid: string) => get(`/property/images?supplier=${supplier}&propertyid=${propertyid}`)

